import { AxiosError, AxiosResponse } from "axios";
import { axiosInstance, axiosInstanceForFileUpload, axiosInstanceWithoutAuth } from "src/services/axiosSetup";
import * as API_URL from "src/services/consts/Report";

export function uploadOABanking(data:any): Promise<any> {
    return axiosInstanceForFileUpload.post(`${API_URL.UPLOAD_OA_BANKING_REPORT}`, data).then((d: AxiosResponse) => d.data);
}

export function uploadTSCReport(data:any): Promise<any> {
    return axiosInstanceForFileUpload.post(`${API_URL.UPLOAD_TS_CONSUMPTION_REPORT}`, data).then((d: AxiosResponse) => d.data);
}

export function getViewTSCConsumtionReport(id: string): Promise<AxiosResponse<any>> {
    return axiosInstance.get(`${API_URL.TS_CONSUMPTION_REPORT_DATA}/${id}`).then((d: AxiosResponse) => d.data)
} 

export function getViewOABankingReport(id: string): Promise<AxiosResponse<any>> {
    return axiosInstance.get(`${API_URL.OA_BANKING_REPORT_DATA}/${id}`).then((d: AxiosResponse) => d.data)
}

export function getOABankingReportList(query: string): Promise<AxiosResponse<any>> {
    return axiosInstance.get(`${API_URL.OA_BANKING_REPORT_LIST}?${query}`).then((d: AxiosResponse) => d.data)
}

export function getTSCConsumptionReportList(query: string): Promise<AxiosResponse<any>> {
    return axiosInstance.get(`${API_URL.TS_CONSUMPTION_REPORT_LIST}?${query}`).then((d: AxiosResponse) => d.data)
}